export default "__VITE_ASSET__CqD_bqey__"